module.exports = __webpack_public_path__ + "img/profile.81b16e5a.svg";